/**
 * defaultDailyDate
 * @returns object
 */
const defaultDailyDate = () => ({
  day: 0,
  hour: 0,
  minute: 0,
});

/**
 * Calculate evergreen time
 * @param {number} day day
 * @param {number} hour hour
 * @param {number} minute minute
 * @param {Object} current current dailyDate
 * @returns {{day: number, hour: number, minute: number}} dailyDate
 */
const smartEvergreen = (
  day: number,
  hour: number,
  minute: number,
  current = { day: 0, hour: 0, minute: 0 },
): { day: number; hour: number; minute: number } => {
  // const addition = {
  //   day: 0,
  //   hour: 0,
  //   min: 0
  // };

  let dailyDate = {
    day: 0,
    hour: 0,
    minute: 0,
  };

  if (current) {
    dailyDate = JSON.parse(JSON.stringify(current));
  }

  if (hour > 59 || minute > 59) {
    dailyDate = defaultDailyDate();
    day = 0;
  }

  if (!isNaN(minute) && minute >= 0 && minute <= 59) {
    dailyDate.minute = minute;
  } else if (minute > 59) {
    hour = Math.floor(minute / 60);
    minute %= 60;
    dailyDate.minute = minute;
  }

  if (!isNaN(hour) && hour >= 0 && hour <= 23) {
    dailyDate.hour = hour;
  } else if (hour >= 24) {
    day = Math.floor(hour / 24);
    hour %= 24;
    dailyDate.hour = hour;
  }

  if (!isNaN(day) && day >= 0) {
    dailyDate.day = day;
  }

  return dailyDate;
};

export default smartEvergreen;
